import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
// import 'bootstrap/dist/css/bootstrap.css'
import React, {useEffect, useState} from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import {Badge, Button, Dialog, DialogContent} from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import {useHistory, useParams} from "react-router";
import BootstrapDialogTitle from "../../helpers/BootstrapDialogTitle";
import OpenDocument from "../../helpers/openDocument";
import {getFileMime} from "../../store/helpers/common_functions";


function ProductDocumentManagement({ location, SetSelectedMenu }) {
    const [open, setOpen] = React.useState(0);
    const [value, setValue] = React.useState({});
    const [list, setList] = React.useState([]);
    const [openView, setOpenView] = useState(false);
    const [fileView, setFileView] = useState(null);
    const [id, setId] = React.useState(null);
    const [count, setCount] = React.useState(0);
    const [info, setInfo] = useState(null);
    const [selected, setSelected] = React.useState(location.state?.status ?? "all");
    const [deleteOpen, setDeleteOpen] = React.useState(false);

    const history = useHistory();
    const {id:vmsId,name} = useParams();

    useEffect(() => {
        setSelected(location.state?.status ?? "all");
    }, [location.state]);


    useEffect(() => {
        SetSelectedMenu({
            menu: "product",
            title: "Product Management"
        })
    }, []);

    const columns = [
        {
            name: "name",
            label: "Name",
        },
        {
            name: "attachment",
            label: "Document",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => <Button onClick={()=>{
                    setOpenView(true);
                    setFileView(value);
                }}>View</Button>,
            },
        },
        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (v) => <BasicMenu onDetails={() => history.push(`/admin/product/${v}`)} onDelete={() => {
                    setDeleteOpen(true);
                    setId(v);
                }} onEdit={() => {
                    setOpen(2);
                    const obj = list.find(vx => vx.id === v);
                    setId(v);
                    setValue0('name', obj.name);
                }} />
            },
        },
    ];
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue(v => {
            v[name] = val;
            return { ...v };
        });
    }
    const onSuccess = () => setCount(v => v + 1);

    return <div className="w-full mb-12 px-4">
        <Dialog maxWidth={'md'} fullWidth={true} open={openView} onClose={() => setOpenView(false)}>
            <BootstrapDialogTitle onClose={() => setOpenView(false)}>Document View</BootstrapDialogTitle>
            <DialogContent>
                {fileView !== null && <OpenDocument
                    downloadable={true}
                    document={fileView}
                    name={'supportDocument'}
                    specialName={fileView}
                    type={"permission-doc"}
                    mimeType={getFileMime(fileView)}/>}
            </DialogContent>
        </Dialog>
        <DeleteDialog open={deleteOpen} setOpen={() => setDeleteOpen(false)} onSuccess={onSuccess} url={`/api/product_docs/delete/${id}`} />
        <FormDialog col={12} open={open > 0} onSuccess={onSuccess} setOpen={(op)=>{
            setOpen(op);
            setId(null);
        }} url={open === 1 ? '/api/product_docs/create' : `/api/product_docs/update/${id}`} title={open === 1 ? "Create New Document" : "Edit Document"} fields={[
            {
                name: "name",
                label: "Name",
                value: value['name'],
                required: true,
                type:'text',
                setValue: (val) => setValue0('name', val),
            },
            {
                name: "document",
                label: "Document",
                type: "file-drag",
                value: value['document'],
                required: !id,
                setValue: (val) => setValue0('document', val),
            },
            {
                name,
                label: "Id",
                type: "hidden",
                hidden:true,
                value: vmsId,
                required: true,
            },
        ]} />
        <DatatableComponent order={location.state?.order} onRowClick={(data, { rowIndex }) => {
            
        }} onAddNew={() => setOpen(1)} processData={(data) => {
            setList(data.data);
            setInfo(data.info);
            return data;
        }} elevation={1} columns={columns} url={`/api/product_docs/list/${vmsId}/${name}?status=${selected}&count=${count}`} title={`${name === 'eventId' ? 'Event' : 'VMS'} Documents ${info?.name || info?.clientName ? `(${info?.name ?? info?.clientName})` : ''}`} />
    </div>;
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDocumentManagement);
